import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/auditorias-fv-inspecciones-qms")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/auditorias-fv-inspecciones-qms", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/farmacovigilancia/auditorias-fv-inspecciones-qms", replace: true });
  },
});
